import { createAction } from '@reduxjs/toolkit'
import type { NProfilesAction } from '@/pages/Profiles/interface'

export const updateSaleRequestType = createAction<NProfilesAction.IUpdateSaleRequestType>('@@profiles/UPDATE_SALE_REQUEST_TYPE')
